import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import enhanceWithClickOutside from 'react-click-outside';
import cn from 'classnames';
import Menu from './Menu';
import { Icon, TextLink } from '@contentful/ui-component-library';

export const Size = {
  Normal: 'normal',
  Large: 'large'
};

export const Style = {
  Button: 'button',
  Link: 'link'
};

const CreateEntryButton = createReactClass({
  propTypes: {
    contentTypes: PropTypes.array.isRequired,
    suggestedContentTypeId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    size: PropTypes.oneOf([Size.Large, Size.Normal]),
    style: PropTypes.oneOf([Style.Button, Style.Link]),
    text: PropTypes.string
  },
  getDefaultProps () {
    return {
      mode: Size.Normal,
      style: Style.Button
    };
  },
  getInitialState () {
    return {
      isOpen: false
    };
  },
  handleClick () {
    this.setState({
      isOpen: !this.state.isOpen
    });

    if (this.props.contentTypes.length === 1) {
      this.props.onSelect(this.props.contentTypes[0].sys.id);
    }
  },
  handleSelect (item) {
    this.setState({
      isOpen: false
    });
    this.props.onSelect(item.sys.id);
  },
  handleClose () {
    this.setState({
      isOpen: false
    });
  },
  handleClickOutside () {
    this.setState({
      isOpen: false
    });
  },
  getCtaText () {
    const { contentTypes, text } = this.props;
    return (
      text || `Add ${contentTypes.length === 1 ? contentTypes[0].name : 'entry'}`
    );
  },
  renderButton () {
    const { contentTypes, size } = this.props;
    const className = cn('btn-action', 'u-truncate', {
      'x--block': size === Size.Large
    });

    return (
      <button
        className={className}
        onClick={this.handleClick}
        data-test-id="cta"
      >
        {this.getCtaText()}
        {contentTypes.length > 1 && (
          <Icon
            icon="MdKeyboardArrowDown"
            size="small"
            color="white"
            data-test-id="dropdown-icon"
            extraClassNames="btn-dropdown-icon"
          />
        )}
      </button>
    );
  },
  renderLink () {
    const { contentTypes } = this.props;
    return (
      <TextLink onClick={this.handleClick} icon="MdAdd">
        {this.getCtaText()}
        {contentTypes.length > 1 && (
          <Icon
            data-test-id="dropdown-icon"
            icon="MdKeyboardArrowDown"
            color="secondary"
            extraClassNames="btn-dropdown-icon"
          />
        )}
      </TextLink>
    );
  },
  renderMenu () {
    const { contentTypes, suggestedContentTypeId } = this.props;
    const { isOpen } = this.state;

    if (contentTypes.length > 1 && isOpen) {
      return (
        <Menu
          contentTypes={contentTypes}
          suggestedContentTypeId={suggestedContentTypeId}
          onSelect={this.handleSelect}
          onClose={this.handleClose}
        />
      );
    } else {
      return null;
    }
  },
  render () {
    const { size } = this.props;
    return (
      <div
        style={{ position: 'relative' }}
        className={cn({
          'x--block': size === Size.Large
        })}
        data-test-id="create-entry"
      >
        {this.props.style === Style.Button
          ? this.renderButton()
          : this.renderLink()}
        {this.renderMenu()}
      </div>
    );
  }
});

export default enhanceWithClickOutside(CreateEntryButton);



// WEBPACK FOOTER //
// ./src/javascripts/components/CreateEntryButton/index.es6.js